import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManagepayoutsComponent } from './managepayouts.component';

const routes: Routes = [
    {
        path: '',
        component: ManagepayoutsComponent,
        data: {
            title: 'Manage Payouts'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ManagePayOutsRoutingModule { }
